/* eslint-disable camelcase */
import { useState } from 'react'

import { InformativeNotesResponse } from '../../@types/fillDataForSimulation'
import { Minus, Plus } from '../Icons'
import {
  BodyContainer,
  HeaderContainer,
  HeaderTitle,
  LegalInformationContainer,
  Paragraph,
} from './styles'

type Props = {
  data: InformativeNotesResponse
}

export const LegalInformation = ({ data }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <LegalInformationContainer>
      <HeaderContainer onClick={toggleOpen}>
        <HeaderTitle isOpen={isOpen}>{data.title}</HeaderTitle>
        {isOpen ? (
          <Minus color="#0093b2" size={24} />
        ) : (
          <Plus color="#0093b2" size={24} />
        )}
      </HeaderContainer>
      <BodyContainer>
        <Paragraph>
          {isOpen ? data.largeDescription : data.shortDescription}
        </Paragraph>
      </BodyContainer>
    </LegalInformationContainer>
  )
}
